import { render, staticRenderFns } from "./DetailTablePainData.vue?vue&type=template&id=0f37bb20&scoped=true"
import script from "./DetailTablePainData.vue?vue&type=script&lang=js"
export * from "./DetailTablePainData.vue?vue&type=script&lang=js"
import style0 from "./DetailTablePainData.vue?vue&type=style&index=0&id=0f37bb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f37bb20",
  null
  
)

export default component.exports